<template>
  <div id="home">
	  <div class="header" id="home-header">
	  		  <div class="logo-box">
	  			  <img class="logo" src="https://cdn.huimiaokeji.com/sv/icon_logo%402x.png"/>
	  		  </div>
	  		  <div class="top-menu">
	  			<div :class='curPage=="home"? "top-menu-item menu-item-active" : "top-menu-item"'  @click="scrollToTop">首页
				<div class="menu-under-line" v-if='curPage=="home"'></div>
				</div>
				<div :class='curPage=="product"? "top-menu-item menu-item-active" : "top-menu-item"' @click="scrollToView('product-section', 'product')">产品服务
				<div class="menu-under-line" v-if='curPage=="product"'></div>
				</div>
	  			<div :class='curPage=="scene"? "top-menu-item menu-item-active" : "top-menu-item"' @click="scrollToView('scene-section', 'scene')">解决方案
				<div class="menu-under-line" v-if='curPage=="scene"'></div>
				</div>
	  			<div :class='curPage=="contact"? "top-menu-item menu-item-active" : "top-menu-item"' @click="scrollToView('contact-section', 'contact')">关于我们
				<div class="menu-under-line" v-if='curPage=="contact"'></div>
				</div>
	  		  </div>
	  		  <div class="login-box">
				  <div class="box-left"></div>
				  <div class="box-center">
					  <div class="login-btn" @click="goToAdmin">
						  登录
					  </div>
					  <div class="login-btn btn-active" @click="goToAdmin">
					  	注册
					  </div>
				  </div>
				  <div class="box-right"></div>
	  		  </div>
	  </div>
    <div class="header-section">
		<div class="header-content">
			<div class="title">
				汇聚星河流量，开启变现新篇
			</div>
			<div class="description">
				一站式流量变现解决方案提供商
			</div>
		</div>
		<div class="bottom-box">
			<div class="box-left"></div>
			<div class="box-center">
				<div class="center-item">
					<div class="item-box">
						<div class="item-title">10000+</div>
						<div class="item-description">合作媒体</div>
					</div>
				</div>
				<div class="center-item">
					<div class="item-box">
						<div class="item-title">100万+</div>
						<div class="item-description">单联盟日收益</div>
					</div>
				</div>
				<div class="center-item">
					<div class="item-box">
						<div class="item-title">5000万+</div>
						<div class="item-description">覆盖用户数</div>
					</div>
				</div>
				<div class="center-item">
					<div class="item-box">
						<div class="item-title">10亿+</div>
						<div class="item-description">日请求数</div>
					</div>
				</div>
			</div>
			<div class="box-right">
				<div class="btn" @click="goToAdmin">
					立即咨询
				</div>
			</div>
		</div>
	</div>
	<div class="product-section" id="product-section">
		<div class="product-box">
			<div class="title">四大核心优势</div>
			<div class="description">务实、专业、服务 ，全面助力开发者</div>
			<div class="product-center">
				<div class="center-left">
					<div :class='curProduct=="1"? "btn btn-active" : "btn" ' @click="changePrt('1')">01更高收益</div>
					<div :class='curProduct=="2"? "btn btn-active" : "btn" ' @click="changePrt('2')">02技术支撑</div>
					<div :class='curProduct=="3"? "btn btn-active" : "btn" ' @click="changePrt('3')">03服务能力</div>
					<div :class='curProduct=="4"? "btn btn-active" : "btn" ' @click="changePrt('4')">04定制内容</div>
				</div>
				<div class="center-right" v-if='curProduct=="1"'>
					<div class="right-left">
						<div class="title">更高的收益</div>
						<div class="description">用创新技术，高效的分配策略，充分发挥技术和资源优势，助力开发者的变现收益最大化</div>
						<div class="btn" @click="goToAdmin" >立即体验</div>
					</div>
					<div class="right-icon">
						<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_income.png"/>
					</div>
				</div>
				<div class="center-right" v-if='curProduct=="2"'>
					<div class="right-left">
						<div class="title">可靠的技术支撑</div>
						<div class="description">APP、H5、小程序全平台支持，创新引擎毫秒级请求响应、大数据挖掘深度防作弊，支持Waterfall和bidding自定义组合，支持媒体API实现完全程序化</div>
						<div class="btn" @click="goToAdmin" >立即体验</div>
					</div>
					<div class="right-icon">
						<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_technology_370%402x.png"/>
					</div>
				</div>
				<div class="center-right" v-if='curProduct=="3"'>
					<div class="right-left">
						<div class="title">专业的服务能力</div>
						<div class="description">超过5年的专业团队，快速服务响应，007技术支持。严控审核优选资源，支持快速先行赔付通道，解决应用后顾，让客户全程省心、放心、可控。</div>
						<div class="btn" @click="goToAdmin" >立即体验</div>
					</div>
					<div class="right-icon">
						<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_service_370%402x.png"/>
					</div>
				</div>
				<div class="center-right" v-if='curProduct=="4"'>
					<div class="right-left">
						<div class="title">定制化的内容支持</div>
						<div class="description">个性化的应用内容支持，为APP解决内容缺乏，长期内容兴趣刺激点降低，用户流失的痛点。减少企业高昂的内容开发和维护成本，同时创造适应的变现场景，进一步激发收益增长。</div>
						<div class="btn" @click="goToAdmin" >立即体验</div>
					</div>
					<div class="right-icon">
						<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_customized_370%402x.png"/>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="platform-section" id="platform-section">
		<div class="platform-box">
			<div class="title">预算充足流量全面</div>
			<div class="description">优质的联盟+直客广告预算，为开发者提供更多元、更高端的广告资源和更高的广告出价</div>
			<div class="platform-center">
				<div class="line"></div>
				<div class="step">
					<div class="num">
						1
					</div>
					<div class="summary">
						APP<br/>向聚合SDK发送请求
					</div>
					<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_ggqq%402x.png">
				</div>
				<div class="gap">
					<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_arrow%402x.png">
					<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_arrow%402x.png">
				</div>
				<div class="step">
					<div class="num">
						2
					</div>
					<div class="summary">
						聚合SDK<br/>
						向广告平台询价
					</div>
					<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_sdk%402x.png">
				</div>
				<div class="gap">
					<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_arrow%402x.png">
					<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_arrow%402x.png">
				</div>
				<div class="step">
					<div class="num">
						3
					</div>
					<div class="summary">
						APP广告曝光<br/>
						价高者得
					</div>
					<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_ggbg%402x.png">
				</div>
			</div>
		</div>
	</div> 
	<div class="scene-section" id="scene-section">
		<div class="scene-box">
			<div class="title">丰富的场景形态</div>
			<div class="description">适配各类场景，跨平台支持APP、小程序、H5</div>
			<div class="scene-center">
				<div class="tab-line">
					<div class="tab-item">
						<div :class='curScene=="1"? "tab-btn tab-btn-active" : "tab-btn"' @click="changeScene('1')">
							开屏
						</div>
					</div>
					<div class="tab-item">
						<div :class='curScene=="2"? "tab-btn tab-btn-active" : "tab-btn"' @click="changeScene('2')">
							激励视频
						</div>
					</div>
					<div class="tab-item">
						<div :class='curScene=="3"? "tab-btn tab-btn-active" : "tab-btn"' @click="changeScene('3')">
							插屏
						</div>
					</div>
					<div class="tab-item">
						<div :class='curScene=="4"? "tab-btn tab-btn-active" : "tab-btn"' @click="changeScene('4')">
							全屏视频
						</div>
					</div>
					<div class="tab-item">
						<div :class='curScene=="5"? "tab-btn tab-btn-active" : "tab-btn"' @click="changeScene('5')">
							原生信息流
						</div>
					</div>
					<div class="tab-item">
						<div :class='curScene=="6"? "tab-btn tab-btn-active" : "tab-btn"' @click="changeScene('6')">
							Banner
						</div>
					</div>
				</div>
				<div class="content-box" v-if="curScene == '1'">
					<div class="content-left">
						<div class="main-box">
							<div class="main-title">开屏</div>
							<div class="main-descript">应用启动时或返回时展示，以头部品牌为主，渗透率、填充率高</div>
							<div class="main-sub-label">推荐场景</div>
							<div class="main-sub-value">应用的启动页</div>
							<div class="main-sub-label">支持平台</div>
							<div class="main-sub-value">APP</div>
							<div class="main-btn" @click="goToAdmin">立即体验</div>
						</div>
					</div>
					<div class="content-right"></div>
					<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_phone_splash.png">
				</div>
				<div class="content-box" v-if="curScene == '2'">
					<div class="content-left">
						<div class="main-box">
							<div class="main-title">激励视频</div>
							<div class="main-descript">用户通过观看视频，获得应用内奖励，同时开发者获得丰厚变现收益</div>
							<div class="main-sub-label">推荐场景</div>
							<div class="main-sub-value">获取应用内任务奖励及权益体系的所有场景</div>
							<div class="main-sub-label">支持平台</div>
							<div class="main-sub-value">APP、小程序</div>
							<div class="main-btn" @click="goToAdmin">立即体验</div>
						</div>
					</div>
					<div class="content-right"></div>
					<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_phone_video%402x.png">
				</div>
				<div class="content-box" v-if="curScene == '3'">
					<div class="content-left">
						<div class="main-box">
							<div class="main-title">插屏</div>
							<div class="main-descript">在用户切换、停顿时，弹出展示，充分渗透用户等待时间，具有极高的点击率和收益表现</div>
							<div class="main-sub-label">推荐场景</div>
							<div class="main-sub-value">操作完成后视频贴片、场景切换等</div>
							<div class="main-sub-label">支持平台</div>
							<div class="main-sub-value">APP、小程序、H5</div>
							<div class="main-btn" @click="goToAdmin">立即体验</div>
						</div>
					</div>
					<div class="content-right"></div>
					<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_phone_Interstitial.png">
				</div>
				<div class="content-box" v-if="curScene == '4'">
					<div class="content-left">
						<div class="main-box">
							<div class="main-title">全屏视频</div>
							<div class="main-descript">全屏播放的视频，支持5秒跳过，高收益的同时兼顾用户体验，支持自渲染</div>
							<div class="main-sub-label">推荐场景</div>
							<div class="main-sub-value">场景切换时、内容翻页、操作完成页等</div>
							<div class="main-sub-label">支持平台</div>
							<div class="main-sub-value">APP、小程序、H5</div>
							<div class="main-btn" @click="goToAdmin">立即体验</div>
						</div>
					</div>
					<div class="content-right"></div>
					<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_phone_screen.png">
				</div>
				<div class="content-box" v-if="curScene == '5'">
					<div class="content-left">
						<div class="main-box">
							<div class="main-title">原生信息流</div>
							<div class="main-descript">完全适应应用原生内容的样式，最大程度的用户体验</div>
							<div class="main-sub-label">推荐场景</div>
							<div class="main-sub-value">推荐列表、资讯页、视频详情页、信息列表页等</div>
							<div class="main-sub-label">支持平台</div>
							<div class="main-sub-value">APP、小程序、H5</div>
							<div class="main-btn" @click="goToAdmin">立即体验</div>
						</div>
					</div>
					<div class="content-right"></div>
					<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_phone_flow.png">
				</div>
				<div class="content-box" v-if="curScene == '6'">
					<div class="content-left">
						<div class="main-box">
							<div class="main-title">Banner</div>
							<div class="main-descript">灵活适应于页面的横幅，具有高曝光率</div>
							<div class="main-sub-label">推荐场景</div>
							<div class="main-sub-value">页面的顶部、中部、底部</div>
							<div class="main-sub-label">支持平台</div>
							<div class="main-sub-value">APP、小程序、H5</div>
							<div class="main-btn" @click="goToAdmin">立即体验</div>
						</div>
					</div>
					<div class="content-right"></div>
					<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_phone_banner%402x.png">
				</div>
			</div>
		</div>
	</div>
	<div class="skill-section" id="skill-section">
		<div class="skill-box">
			<div class="title">完善的核心能力</div>
			<div class="description">为媒体提供全方位一站式服务，保证预算充分填充和高效成交</div>
			<div class="skill-center">
				<div class="item-line">
					<div class="item">
						<div class="item-content">
							<div class="content-title">
								<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_bid_44%402x.png">
								<div class="icon-title">
									Waterfall和bidding
								</div>
							</div>
							<div class="content-summary">
								支持多家联盟参与实时竞价，在保持充分填充的情况下，最大化成交价格。实测效果，应用整体收益提升10-30%
							</div>
						</div>
					</div>
					<div class="item">
						<div class="item-content">
							<div class="content-title">
								<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_serial_44%402x.png">
								<div class="icon-title">
									并串行自定义
								</div>
							</div>
							<div class="content-summary">
								支持自定义请求策略，还可以根据不同的场景设定多种组合方式，同时支持分别配置不同的层级策略
							</div>
						</div>
					</div>
					<div class="item">
						<div class="item-content">
							<div class="content-title">
								<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_real_44%402x.png">
								<div class="icon-title">
									实时热更新
								</div>
							</div>
							<div class="content-summary">
								支持热更新开启，实时在线提供赋能、修复错误，避免应用反复发版的问题，提升开发效率
							</div>
						</div>
					</div>
				</div>
				<div class="item-line">
					<div class="item">
						<div class="item-content">
							<div class="content-title">
								<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_diagnosis_44%402x.png">
								<div class="icon-title">
									实时诊断
								</div>
							</div>
							<div class="content-summary">
								实时监控异常情况，错误信息实时上报，及时提供调优支持。最大化提升流量的利用效率
							</div>
						</div>
					</div>
					<div class="item">
						<div class="item-content">
							<div class="content-title">
								<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_timeout_44%402x.png">
								<div class="icon-title">
									超时和容错
								</div>
							</div>
							<div class="content-summary">
								支持超时设置以及自定义错误策略，极大的提高了请求效率以及用户体验性，实测效果提高有效率20-50%
							</div>
						</div>
					</div>
					<div class="item item-hide"></div>
				</div>
			</div>
		</div>
	</div>
	<div class="dev-section" id="dev-section">
		<div class="dev-box">
			<div class="title">一站式接入 快速方便</div>
			<div class="description">快速入驻，对接更便利合作流程更简单</div>
			<div class="dev-center">
				<div class="dev-row">
					<div class="row-item">
						<div class="num">01</div>
						<div class="item-content">
							<div class="dev-title">沟通合作</div>
							<div class="dev-descript">专业运营沟通需求</div>
						</div>
					</div>
					<div class="gap">
						<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_arrow_2%402x.png">
					</div>
					<div class="row-item">
						<div class="num">02</div>
						<div class="item-content">
							<div class="dev-title">制定方案</div>
							<div class="dev-descript">制定变现场景方案</div>
						</div>
					</div>
					<div class="gap">
						<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_arrow_2%402x.png">
					</div>
					<div class="row-item">
						<div class="num">03</div>
						<div class="item-content">
							<div class="dev-title">对接工作</div>
							<div class="dev-descript">收集相关资料信息</div>
						</div>
					</div>
					<div class="gap">
						<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_arrow_2%402x.png">
					</div>
					<div class="row-item">
						<div class="num">04</div>
						<div class="item-content">
							<div class="dev-title">开始对接</div>
							<div class="dev-descript">全流程提供技术服务支持</div>
						</div>
					</div>
				</div>
				<div class="dev-row">
					<div class="row-item">
						<div class="num">05</div>
						<div class="item-content">
							<div class="dev-title">测试验收</div>
							<div class="dev-descript">验收对接展现情况</div>
						</div>
					</div>
					<div class="gap">
						<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_arrow_2%402x.png">
					</div>
					<div class="row-item">
						<div class="num">06</div>
						<div class="item-content">
							<div class="dev-title">SDK上线</div>
							<div class="dev-descript">稳定产出收益</div>
						</div>
					</div>
					<div class="gap">
						<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_arrow_2%402x.png">
					</div>
					<div class="row-item">
						<div class="num">07</div>
						<div class="item-content">
							<div class="dev-title">运营调优</div>
							<div class="dev-descript">监测数据及调优策略</div>
						</div>
					</div>
					<div class="gap">
						<img class="icon" src="https://cdn.huimiaokeji.com/sv/icon_arrow_2%402x.png">
					</div>
					<div class="row-item">
						<div class="num">08</div>
						<div class="item-content">
							<div class="dev-title">结算支付</div>
							<div class="dev-descript">流程化结算收益快速到账</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="partner-section" id="partner-section">
		<div class="partner-box">
			<div class="title">合作伙伴</div>
			<div class="description">值得信赖，成为合作伙伴的优先选择</div>
			<div class="partner-center">
				<div class="logo-row" v-if="curPartner=='1'">
					<img class="brand-icon" src="https://cdn.huimiaokeji.com/sv/logo_kwai%402x.png">
					<img class="brand-icon" src="https://cdn.huimiaokeji.com/sv/logo_baidu%402x.png">
					<img class="brand-icon" src="https://cdn.huimiaokeji.com/sv/logo_proya%402x.png">
					<img class="brand-icon" src="https://cdn.huimiaokeji.com/sv/logo_pangolin%402x.png">
				</div>
				<div class="logo-row" v-if="curPartner=='1'">
					<img class="brand-icon" src="https://cdn.huimiaokeji.com/sv/logo_tencent%402x.png">
					<img class="brand-icon" src="https://cdn.huimiaokeji.com/sv/logo_vivo%402x.png">
					<img class="brand-icon" src="https://cdn.huimiaokeji.com/sv/logo_china_unicom%402x.png">
					<img class="brand-icon" src="https://cdn.huimiaokeji.com/sv/logo_china_mobile%402x.png">
				</div>
				<div class="logo-row" v-if="curPartner=='2'">
					<img class="brand-icon" src="https://cdn.huimiaokeji.com/sv/logo_telecom%402x.png">
					<img class="brand-icon" src="https://cdn.huimiaokeji.com/sv/logo_headlines%402x.png">
					<img class="brand-icon" src="https://cdn.huimiaokeji.com/sv/logo_huawei%402x.png">
					<img class="brand-icon" src="https://cdn.huimiaokeji.com/sv/logo_alipay%402x.png">
				</div>
				<div class="logo-row" v-if="curPartner=='2'">
					<img class="brand-icon" src="https://cdn.huimiaokeji.com/sv/logo_redbook%402x.png">
					<img class="brand-icon" src="https://cdn.huimiaokeji.com/sv/logo_pingan%402x.png">
					<img class="brand-icon" src="https://cdn.huimiaokeji.com/sv/logo_netease%402x.png">
					<img class="brand-icon" src="https://cdn.huimiaokeji.com/sv/logo_spdbank%402x.png">
				</div>
				<div class="logo-row" v-if="curPartner=='3'">
					<img class="brand-icon" src="https://cdn.huimiaokeji.com/sv/logo_septwolves%402x.png">
					<img class="brand-icon" src="https://cdn.huimiaokeji.com/sv/logo_wufangame%402x.png">
					<img class="brand-icon" src="https://cdn.huimiaokeji.com/sv/logo_sina%402x.png">
					<img class="brand-icon" src="https://cdn.huimiaokeji.com/sv/logo_rivals%402x.png">
				</div>
				<div class="logo-row" v-if="curPartner=='3'" style="height: 99px;">
					
				</div>
				<div class="tab-line">
					<div class="tab-box">
						<div :class='curPartner=="1"? "tab-item item-active" : "tab-item"' @click="changePartner('1')"></div>
						<div :class='curPartner=="2"? "tab-item item-active" : "tab-item"' @click="changePartner('2')"></div>
						<div :class='curPartner=="3"? "tab-item item-active" : "tab-item"' @click="changePartner('3')"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="contact-section" id="contact-section">
		<div class="contact-box">
			<div class="left">
				<div class="title">星河聚量 —— 开启流量变现新宇宙</div>
				<div class="description">在当今数字化浪潮中，流量已然成为商业世界的璀璨星辰，蕴含着无限潜力与价值。而 “星河聚量”，作为一家专注于流量变现出海的广告公司，正致力于在这片星河中，精准丈量、开拓出独属于客户的价值领域。</div>
			</div>
			<div class="right">
				<img class="icon" src="https://cdn.huimiaokeji.com/sv/pic_photo.jpg">
			</div>
		</div>
	</div>
	<div class="contact-section2" id="contact-section">
		<div class="contact-box">
			<div class="left">
				<img class="icon" src="https://cdn.huimiaokeji.com/sv/pic_photo_2.jpg">
			</div>
			<div class="right">
				<div class="title">我们的团队</div>
				<div class="description">星河聚量，正以其对全球流量的深刻理解、精准丈量的专业能力、创新领航的进取精神以及多元服务的生态构建，在流量变现出海的征程中，带领客户穿越浩瀚星河，开拓出属于他们的广阔商业版图，开启流量变现的新宇宙篇章。</div>
				<div class="btn" @click="goToAdmin">开始变现</div>
			</div>
		</div>
	</div>
	<!-- <footer-menu></footer-menu> -->
  </div>
</template>

<script>
	import HeaderMenu from '../components/header-menu.vue';
	import FooterMenu from '../components/footer-menu.vue';
export default {
	name:'home',
	components: {
		HeaderMenu,
		FooterMenu
	},
	data() {
		return {
			curPage: 'home',
			curProduct: '1',
			curPartner: '1',
			curScene: '1'
		}
	},
	created() {
	  document.title = '星河聚量-首页';
	},
  methods: {
	  navTo(url, page) {
	  	this.curPage = page;
	  	this.$router.push({ path:url})
	  },
	  gotoTop() {
		location.reload();
	  },
	  goUrl(url){
		   window.open(url);
	  },
	  goToAdmin(){
	  	  this.goUrl('https://admin.xinghmoq.top')
	  },
	  scrollToTop() {
		  this.curPage="home";
	      const rootElement = document.documentElement || document.body;
	      rootElement.scrollTo({
	          top: 0,
	          behavior: "smooth"
	      });
	  },
	  scrollToView(id, page) {
		  this.curPage = page;
		  let element = document.getElementById(id);
		  element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
	  },
	  changePrt(prt) {
		  this.curProduct = prt;
	  },
	  changePartner(partner) {
	  		this.curPartner = partner;
	  },
	  changeScene(scene) {
	  		this.curScene = scene;
	  }
  }
}
</script>

<style lang="less">
#home {
  background-color: #F2F2F6;
  .header {
	  width: 100%;
	  z-index: 999999;
	  position: fixed;
	  left: 0;
	  top:0 ;
  	  display: flex;
  	   height: 80px;
	   background-color: #26233B;
  	  .logo-box {
  		  flex:1;
  		  display: flex;
  		  align-items: center;
  		  .logo {
  			margin-left: 40px;
  			width: 136px;	
  			height: 46px;
  		  }
  	  }
  	  .top-menu{
  		  flex:1;
  			  font-size: 18px;
  			  font-family: Roboto, Roboto;
  			  font-weight: normal;
  			  color: #FFFFFF;
  			  line-height: 80px;
  			  display: flex;
  			  justify-content: space-between;
  			  padding-left: 100px;
  			  padding-right: 100px;
  			  .top-menu-item {
  				  cursor: pointer;
				  position:relative;
				  .menu-under-line {
					  height: 6px;
					  width: 100%;
					  background: #26B9EA;
					  border-radius: 2px;
					  position:absolute;
					  bottom: 12px;
				  }
  			  }
  			  .menu-item-active {
  				  color: #26B9EA;
  				  font-weight: bold;
  			  }
  	  }
  	  .login-box {
  		  flex:1;
		  display: flex;
		  .box-left {
			flex:1;
		  }
		  .box-center {
		  	flex:2;
			display: flex;
			align-items: center;
			justify-content: center;
			.login-btn {
				cursor: pointer;
				height: 46px;
				width: 115px;
				font-family: Roboto, Roboto;
				font-weight: 400;
				font-size: 18px;
				color: #FFFFFF;
				line-height: 46px;
				text-align: center;
				font-style: normal;
			}
			.btn-active {
				background: #26B9EA;
				border-radius: 2px;
			}
		  }
		  .box-right {
			flex:1;
		  }
  	  }
    }
  .header-section {
	  margin-top: 80px;
	  aspect-ratio: 1920 / 600;
  	  background: url(https://cdn.huimiaokeji.com/sv/banner_home.jpg) no-repeat;
  	  background-size: cover;
  	  width:100%;
	  position: relative;
	  .header-content {
		  position: absolute; /* 子元素绝对定位 */
				// padding-left: 16%;
				top: 36.6667%;
				width: 100%;
	  		  .title {
				  font-family: Montserrat, Montserrat;
				  font-weight: 400;
				  font-size: 60px;
				  color: #FFFFFF;
				  line-height: 60px;
				  letter-spacing: 1px;
				  text-align: center;
				  font-style: normal;
	  		  }
			  .description {
				  margin-top: 45px;
				  font-family: Montserrat, Montserrat;
				  font-weight: 400;
				  font-size: 24px;
				  color: #C8C8C8;
				  line-height: 24px;
				  letter-spacing: 2px;
				  text-align: center;
				  font-style: normal;
			  }
	  	  }
		  .bottom-box {
		    position: absolute;
		    bottom: 0;
		    width: 100%;
		    height: 24.3333%; /* 146 ÷ 600 = 0.243333 */
		    background: rgba(38, 35, 59, 0.8);
			display: flex;
			.box-left {
				flex:1;
			}
			.box-center {
				flex:4;
				display: flex;
				.center-item{
					flex:1;
					display: flex;
					align-items: center;
					justify-content: center;
					.item-box{
						.item-title {
							font-family: PingFangSC, PingFang SC;
							font-weight: bold;
							font-size: 40px;
							color: #FFFFFF;
							text-align: center;
							font-style: normal;
						}
						.item-description{
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 24px;
							color: #FFFFFF;
							letter-spacing: 1px;
							text-align: center;
							font-style: normal;
						}
					}
				}
			}
			.box-right {
				flex:1;
				display: flex;
				align-items: center;
				.btn {
					cursor: pointer;
					height: 60px;
					width: 200px;
					font-family: PingFangSC, PingFang SC;
					font-weight: bold;
					font-size: 20px;
					color: #FFFFFF;
					line-height: 60px;
					text-align: center;
					font-style: normal;
					background: #26B9EA;
					border-radius: 5px;
				}
			}
		  }
		  
  }
  .product-section {
  	width: 100%;
  	height: 880px;
  	background: #F2F2F6;
  	.product-box {
  		width: 66%;
  		margin-left: 17%;
  		padding-top: 100px;
  		.title {
  			font-family: PingFangSC, PingFang SC;
  			font-weight: bold;
  			font-size: 46px;
  			color: #1A233B;
  			text-align: left;
  			font-style: normal;
  		}
  		.description {
  			margin-top: 28px;
  			font-family: PingFangSC, PingFang SC;
  			font-weight: 400;
  			font-size: 20px;
  			color: #797889;
  			text-align: left;
  			font-style: normal;
  		}
  		.product-center {
  			margin-top: 66px;
  			display: flex;
  			height: 480px;
  			.center-left {
  				width: calc(100% * 0.66 * (400 / 902));
  				display: flex;
  			  flex-direction: column;
  			  justify-content: space-between;
  			  .btn {
				  cursor: pointer;
  				  width: 100%;
  					height: calc(100% * 0.66 * (400 / 902) * (160/272));
  					background: #FFFFFF;
  					border-radius: 2px;
  					font-family: PingFangSC, PingFang SC;
  					font-weight: bold;
  					font-size: 25px;
  					color: #26B9EA;
  					letter-spacing: 1px;
  					text-align: center;
  					font-style: normal;
  					display: flex;
  					align-items: center; /* 垂直居中 */
  					justify-content: center;
  			  }
  			  .btn-active {
  				  background: #26B9EA;
  				  color: #FFFFFF;
  			  }
  			}
  			.center-right {
  				margin-left: calc(100% * 0.66 * (60 / 902));
  				width: 100%;
  				background: #FFFFFF;
  				padding:100px;
  				display: flex;
  				.right-left {
  					flex:1.5;
  					.title {
  						font-family: PingFangSC, PingFang SC;
  						font-weight: bold;
  						font-size: 28px;
  						color: #333333;
  						line-height: 36px;
  						text-align: left;
  						font-style: normal;
  					}
  					.description {
  						font-family: PingFangSC, PingFang SC;
  						font-weight: 400;
  						font-size: 16px;
  						color: #666666;
  						line-height: 25px;
  						text-align: left;
  						font-style: normal
  					}
  					.btn {
						cursor: pointer;
  						margin-top: 60px;
  						width: 205px;
  						height: 62px;
  						background: #26B9EA;
  						border-radius: 2px;
  						font-family: PingFangSC, PingFang SC;
  						font-weight: bold;
  						font-size: 20px;
  						color: #FFFFFF;
  						line-height: 62px;
  						text-align: center;
  						font-style: normal;
  					}
  				}
  				.right-icon {
  					flex:1;
  					display: flex;
  					justify-content: center;
  					.icon {
  						width: 290px;
  						height: 290px;
  					}
  				}
  			}
  		}
  	}
  }
	.platform-section{
		width: 100%;
		height: 1000px;
		background: #FFFFFF;
		.platform-box {
			width: 66%;
			margin-left: 17%;
			padding-top: 100px;
			.title {
				font-family: PingFangSC, PingFang SC;
				font-weight: bold;
				font-size: 46px;
				color: #1A233B;
				text-align: left;
				font-style: normal;
			}
			.description {
				margin-top: 28px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 20px;
				color: #797889;
				text-align: left;
				font-style: normal;
			}
			.platform-center {
				margin-top: 66px;
				display: flex;
				height: 629px;
				position: relative;
				.line {
					position: absolute;
					width: calc(100% * 0.75);
					height: 10px;
					background: #D9E0E7;
					top:  25px;
					left: calc(100% * 0.125);
					z-index: 0;
				}
				.step {
					width:25%;
					display: flex;
					align-items: center;
					flex-direction: column; 
					z-index: 2;
					.num {
						width: 50px;
						  height: 50px;
						  background: #26B9EA;
						  border-radius: 50%; /* 关键属性：圆角半径设为50% */
						  font-family: PingFangSC, PingFang SC;
						  font-weight: bold;
						  font-size: 30px;
						  color: #FFFFFF;
						  line-height: 50px;
						  text-align: center;
						  font-style: normal;
					}
					.summary {
						margin-top: 30px;
						font-family: PingFangSC, PingFang SC;
						font-weight: bold;
						font-size: 25px;
						color: #333333;
						text-align: center;
						font-style: normal;
					}
					.icon {
						margin-top: 40px;
						 display: block;       /* 消除图片默认的底部间隙 */
						  height: 450px;        /* 固定高度（按需调整数值） */
						  width: auto;          /* 宽度自适应（可不写，默认行为） */
						  object-fit: contain;  /* 保持图片比例完整显示 */
					}
				}
				.gap {
					width:12.5%;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					height: 100%;
					padding-top: 60px;
					.icon {
						width: 43.2px;
						height: 20px;
						margin-top: 80px;
					}
				}
			}
		}
	}
	.partner-section{
		width: 100%;
		height: 700px;
		background: #F2F2F6;
		.partner-box {
			width: 66%;
			margin-left: 17%;
			padding-top: 100px;
			.title {
				font-family: PingFangSC, PingFang SC;
				font-weight: bold;
				font-size: 46px;
				color: #1A233B;
				text-align: left;
				font-style: normal;
			}
			.description {
				margin-top: 28px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 20px;
				color: #797889;
				text-align: left;
				font-style: normal;
			}
			.partner-center{
				margin-top: 86px;
				.logo-row {
					 display: flex;
					 justify-content: space-between;
					 .brand-icon{
						 width: 220px;
						 height: 99px;
					 }
					 margin-bottom: 40px;
				}
				.tab-line {
					display: flex;
					justify-content: center;
					.tab-box {
						margin-top: 25px;
						width: 220px;
						height: 5px;
						display: flex;
						justify-content: space-between;
						.tab-item {
							cursor: pointer;
							width: 60px;
							height: 5px;
							border-radius: 2px;
							background: #C5C4CA;
						}
						.item-active {
							background: #26B9EA;
						}
					}
				}
			}
		}
	}
	.scene-section {
		width: 100%;
		height: 1010px;
		background: #FFFFFF;
		.scene-box {
			width: 66%;
			margin-left: 17%;
			padding-top: 100px;
			.title {
				font-family: PingFangSC, PingFang SC;
				font-weight: bold;
				font-size: 46px;
				color: #1A233B;
				text-align: left;
				font-style: normal;
			}
			.description {
				margin-top: 28px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 20px;
				color: #797889;
				text-align: left;
				font-style: normal;
			}
			.scene-center{
				margin-top: 40px;
				.tab-line {
					display: flex;
					height: 68px;
					background: #EBF5FF;
					border-radius: 52px;
					align-items: center;
					.tab-item{
						flex: 1;
						display: flex;
						justify-content: center;
						.tab-btn {
							cursor: pointer;
							padding: 2px 30px;
							height: 35px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 18px;
							color: #333333;
							line-height: 35px;
							text-align: center;
							font-style: normal;
						}
						.tab-btn-active{
							background: #C4E9FB;
							border-radius: 32px;
							font-weight: bold;
						}
					}
				}
				.content-box {
					margin-top: 80px;
					display: flex;
					position: relative;
					height: 600px;   
					.icon {
						position: absolute;
						display: block;       /* 消除图片默认的底部间隙 */
						 height: 500px;        /* 固定高度（按需调整数值） */
						 width: auto;          /* 宽度自适应（可不写，默认行为） */
						 object-fit: contain;  /* 保持图片比例完整显示 */
						 right: 0;
						 bottom: 0;
					}
					.content-left {
						flex: 2.5;
						.main-box {
							padding-left: 20px;
							padding-right: 60px;
							.main-title {
								font-family: PingFangSC, PingFang SC;
								font-weight: bold;
								font-size: 40px;
								color: #333333;
								line-height: 40px;
								letter-spacing: 2px;
								text-align: left;
								font-style: normal;
							}
							.main-descript {
								margin-top: 30px;
								font-family: PingFangSC, PingFang SC;
								font-weight: 400;
								font-size: 24px;
								color: #67648E;
								line-height: 32px;
								text-align: left;
								font-style: normal;
							}
							.main-sub-label {
								margin-top: 70px;
								font-family: PingFangSC, PingFang SC;
								font-weight: 400;
								font-size: 18px;
								color: #6B6B7C;
								line-height: 18px;
								text-align: left;
								font-style: normal;
							}
							.main-sub-value {
								margin-top: 24px;
								font-family: PingFangSC, PingFang SC;
								font-weight: 400;
								font-size: 24px;
								color: #333333;
								line-height: 24px;
								text-align: left;
								font-style: normal;
							}
							.main-btn {
								cursor: pointer;
								margin-top: 80px;
								width: 205px;
								height: 62px;
								background: #26B9EA;
								border-radius: 2px;
								font-family: PingFangSC, PingFang SC;
								font-weight: bold;
								font-size: 20px;
								color: #FFFFFF;
								line-height: 62px;
								text-align: center;
								font-style: normal;
							}
						}
					}
					.content-right {
						flex: 1;
					}
				}
			}
		}
	}
	.skill-section {
		width: 100%;
		height: 800px;
		background: #F2F2F6;
		.skill-box {
			width: 66%;
			margin-left: 17%;
			padding-top: 100px;
			.title {
				font-family: PingFangSC, PingFang SC;
				font-weight: bold;
				font-size: 46px;
				color: #1A233B;
				text-align: left;
				font-style: normal;
			}
			.description {
				margin-top: 28px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 20px;
				color: #797889;
				text-align: left;
				font-style: normal;
			}
			.skill-center{
				margin-top: 65px;
				.item-line {
					display: flex;
					justify-content: center;
					margin-bottom: 40px;
					.item {
						width: 303px;
						height: 185px;
						background: #FFFFFF;
						box-shadow: 0px 2px 30px 0px rgba(129,138,164,0.2);
						border-radius: 10px;
						&:not(:last-child) {
							margin-right: 20px;
						}
						.item-content {
							padding: 20px;
							.content-title {
								height: 50px;
								background: #F5FAFF;
								border-radius: 2px;
								display: flex;
								justify-content: center;
								align-items: center;
								.icon {
									width: 18px;
									height: 18px;
									margin-right: 10px;
								}
								.icon-title {
									font-family: PingFangSC, PingFang SC;
									font-weight: bold;
									font-size: 20px;
									color: #26B9EA;
									line-height: 50px;
									font-style: normal;
								}
							}
							.content-summary{
								margin-top: 20px;
								font-family: PingFangSC, PingFang SC;
								font-weight: 400;
								font-size: 14px;
								color: #666666;
								line-height: 20px;
								text-align: justify;
								font-style: normal;
							}
						}
					}
					.item-hide {
						background: #F2F2F6;
						box-shadow:none;
					}
				}
			}
		}
	}
	.dev-section{
		width: 100%;
		height: 700px;
		background: #FFFFFF;
		.dev-box {
			width: 66%;
			margin-left: 17%;
			padding-top: 100px;
			.title {
				font-family: PingFangSC, PingFang SC;
				font-weight: bold;
				font-size: 46px;
				color: #1A233B;
				text-align: left;
				font-style: normal;
			}
			.description {
				margin-top: 28px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 20px;
				color: #797889;
				text-align: left;
				font-style: normal;
			}
			.dev-center{
				margin-top: 108px;
				.dev-row {
					height: 83px;
					display: flex;
					margin-bottom: 150px;
					.row-item {
						width: 21%;
						display: flex;
						.num {
							width: 55px;
							height: 83px;
							font-family: DINAlternate, DINAlternate;
							font-weight: bold;
							font-size: 50px;
							color: #26B9EA;
							line-height: 83px;
							text-align: left;
							font-style: normal;
							margin-right: 10px;
						}
						.item-content {
							display: flex;
							flex-direction: column;
							justify-content: center;
							.dev-title {
								font-family: PingFangSC, PingFang SC;
								font-weight: bold;
								font-size: 20px;
								color: #333333;
								line-height: 30px;
								letter-spacing: 1px;
								text-align: left;
								font-style: normal;
							}
							.dev-descript {
								margin-top: 5px;
								font-family: PingFangSC, PingFang SC;
								font-weight: 400;
								font-size: 12px;
								color: #666666;
								line-height: 18px;
								text-align: left;
								font-style: normal;
							}
						}
					}
					.gap {
						width: 5.33%;
						display: flex;
						align-items: center;
						.icon {
							width: 30px;
							height: 16.5px;
						}
					}
				}
			}
		}	
	}
	.contact-section{
		width: 100%;
		height: 500px;
		background: #F8F9FC;
		.contact-box {
			width: 66%;
			margin-left: 17%;
			display: flex;
			height: 100%;
			.left {
				flex:1;
				display: flex;
				flex-direction: column;
				justify-content: center;
				height: 100%;
				.title {
					font-family: PingFangSC, PingFang SC;
					font-weight: bold;
					font-size: 28px;
					color: #333333;
					line-height: 32px;
					text-align: left;
					font-style: normal;
				}
				.description {
					margin-top: 44px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 16px;
					color: #333333;
					line-height: 25px;
					text-align: justify;
					font-style: normal;
					padding-right: 30px;
				}
			}
			.right {
				flex:1;
				display: flex;
				justify-content: center;
				align-items: center;
				.icon {
					display: block;       /* 消除图片默认的底部间隙 */
					 height: 280px;        /* 固定高度（按需调整数值） */
					 width: auto;          /* 宽度自适应（可不写，默认行为） */
					 object-fit: contain;  /* 保持图片比例完整显示 */
				}
			}
		}
	}
	.contact-section2{
		width: 100%;
		height: 500px;
		background: #FFFFFF;
		.contact-box {
			width: 66%;
			margin-left: 17%;
			display: flex;
			height: 100%;
			.left {
				flex:1;
				display: flex;
				justify-content: center;
				align-items: center;
				.icon {
					display: block;       /* 消除图片默认的底部间隙 */
					 height: 280px;        /* 固定高度（按需调整数值） */
					 width: auto;          /* 宽度自适应（可不写，默认行为） */
					 object-fit: contain;  /* 保持图片比例完整显示 */
				}
			}
			.right {
				flex:1;
				display: flex;
				flex-direction: column;
				justify-content: center;
				height: 100%;
				.title {
					padding-left: 50px;
					font-family: PingFangSC, PingFang SC;
					font-weight: bold;
					font-size: 28px;
					color: #333333;
					line-height: 32px;
					text-align: left;
					font-style: normal;
				}
				.description {
					padding-left: 50px;
					margin-top: 44px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 16px;
					color: #333333;
					line-height: 25px;
					text-align: justify;
					font-style: normal;
					padding-right: 30px;
				}
				.btn {
					cursor: pointer;
					width: 205px;
					height: 62px;
					margin-left: 50px;
					margin-top: 40px;
					background: #26B9EA;
					border-radius: 5px;
					font-family: PingFangSC, PingFang SC;
					font-weight: bold;
					font-size: 20px;
					color: #FFFFFF;
					line-height: 62px;
					text-align: center;
					font-style: normal;
				}
			}
		}
	}
}

</style>



// WEBPACK FOOTER //
// src/pages/Home.vue